export default __webpack_public_path__ + "static/wunschpiercing-8-be1d85ad341572bdf917a2db16be3bdd.jpg";